import React from 'react'
import injectSheet from 'react-jss'
import styles from './bulk-actions.styles'
import { ActionButton } from 'pobble-components/dist/bulk-action'
import { openConfirmationDialog } from 'pobble-components/dist/modal/confirmation-dialog'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faFileAlt } from '@fortawesome/pro-regular-svg-icons/faFileAlt'
import { faTrashAlt } from '@fortawesome/pro-regular-svg-icons/faTrashAlt'
import {
  useSubscriptionPolicy,
  SubsCrown
} from 'pobble-components/dist/subscriptions'

const BulkActions = ({ classes, onDelete, onOpenCreateAssessmentDialog }) => {
  const createAssesmenFileSP = useSubscriptionPolicy(
    sp => sp.moderation.create_assessment_file
  )
  const moderationSP = useSubscriptionPolicy(sp => sp.moderation)
  return (
    <ActionButton>
      {({ Menu, MenuItem, IconHolder, closePopover, bulkSelectedList }) => (
        <Menu>
          <MenuItem
            className={classes.delete}
            onClick={() => {
              closePopover()
              openConfirmationDialog({
                bodyText: `Are you sure you want to delete ${
                  bulkSelectedList.length
                } works`,
                confirmText: `Delete works`,
                action: () => onDelete(bulkSelectedList)
              })
            }}>
            <IconHolder>
              <FontAwesomeIcon icon={faTrashAlt} />
            </IconHolder>
            Delete works
          </MenuItem>
          <MenuItem
            onClick={() => {
              closePopover()
              if (createAssesmenFileSP.restricted)
                return moderationSP.showDialog()
              onOpenCreateAssessmentDialog(bulkSelectedList)
            }}>
            <IconHolder>
              {createAssesmenFileSP.restricted && <SubsCrown />}
              {!createAssesmenFileSP.restricted && (
                <FontAwesomeIcon icon={faFileAlt} />
              )}
            </IconHolder>
            Create moderation file
          </MenuItem>
        </Menu>
      )}
    </ActionButton>
  )
}

export default injectSheet(styles)(BulkActions)
